// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f-Scl","importantInfo":"styles_importantInfo__3gNDV"};